/**
 * Notification Navigation Utility
 *
 * Encapsulated routing logic for notifications.
 * Single source of truth for mapping notification types to routes.
 */

import { NavigateFunction } from 'react-router-dom';
import { Notification, RelatedEntityType } from '../features/notifications/notificationsSlice';

/**
 * Get the navigation URL for a notification based on its related entity
 */
export function getNotificationUrl(notification: Notification): string | null {
  if (!notification.relatedEntityType || !notification.relatedEntityId) {
    return null;
  }

  const metadata = notification.metadata ? JSON.parse(notification.metadata) : {};

  switch (notification.relatedEntityType) {
    case RelatedEntityType.Course:
      return `/course/${notification.relatedEntityId}`;

    case RelatedEntityType.AssignmentDefinition:
      const courseId = metadata?.CourseId;
      return courseId ? `/course/${courseId}` : null;

    case RelatedEntityType.Announcement:
      // Future: could be a dedicated announcements page
      return null;

    case RelatedEntityType.Message:
      // Future: could be a messages/inbox page
      return null;

    case RelatedEntityType.System:
      // System notifications typically don't navigate anywhere
      return null;

    default:
      return null;
  }
}

/**
 * Handle notification click - navigate if there's a related entity
 */
export function handleNotificationClick(
  notification: Notification,
  navigate: NavigateFunction
): void {
  const url = getNotificationUrl(notification);
  if (url) {
    navigate(url);
  }
}
